// extracted by mini-css-extract-plugin
export default {"wrapper":"OutsourceAnother_wrapper__lk+9t","title":"OutsourceAnother_title__-X6tX","container":"OutsourceAnother_container__Itnbk"};